import { Button } from "@mui/joy";
import useNow from "hooks/useNow";
import { formatClock } from "logic/autoFillPanel";
import { Spinner } from "./AutoFillProgress";

// 웹 — 채우는 중일 때 [자동 채우기] 자리. 누르면 오른쪽 아래 진행 표시를 펼친다
export default function AutoFillRunningButton({
  startedAt,
  onClick,
}: {
  startedAt: number;
  onClick: () => void;
}) {
  const now = useNow(true);
  const seconds = Math.max(0, Math.floor((now - startedAt) / 1000));
  return (
    <Button
      size="sm"
      variant="Outlined"
      startDecorator={<Spinner size="16px" />}
      onClick={onClick}
      sx={{
        whiteSpace: "nowrap",
        flexShrink: 0,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {`채우는 중 ${formatClock(seconds)}`}
    </Button>
  );
}
